export default __webpack_public_path__ + "static/media/magicsnacks@3x.6564630a.jpg";